enum SphereRobotTabs {
  Dashboard = "dashboard",
  History = "history",
  Missions = "missions",
  Users = "users",
  Settings = "settings",
  MapPlanner = "map-planner",
  Scheduler = "scheduler",
  MapConfiguration = "map-configuration",
  RoomOverview = "room-overview",

  InteractionAnnouncement = "robot-interaction",
}

export default SphereRobotTabs;